import { lazy, Suspense } from 'react';
import { Navigate, type RouteObject } from 'react-router';
import { Guard } from '@/modules/shared/components/guard';

const Login = lazy(() => import('./pages/login'));
const ProfileSelector = lazy(() => import('./pages/profile-selector'));
const LeaderboardTurmas = lazy(() => import('./pages/leaderboard-turmas'));

const GuardWithSuspense = ({ children, allowedRoles, allowSuperWithoutSchool }: {
  children: React.ReactNode;
  allowedRoles: any[];
  allowSuperWithoutSchool?: boolean;
}) => (
  <Suspense fallback={<div className="min-h-screen" />}>
    <Guard allowedRoles={allowedRoles} allowSuperWithoutSchool={allowSuperWithoutSchool}>
      {children}
    </Guard>
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/login',
    element: (
      <Suspense fallback={<div className="min-h-screen" />}>
        <Login />
      </Suspense>
    ),
    handle: { crumb: null }
  },
  {
    path: '/profile',
    element: (
      <GuardWithSuspense allowedRoles={['SUPER', 'ADM', 'PROFESSOR', 'RESPONSAVEL', 'ALUNO']}>
        <ProfileSelector />
      </GuardWithSuspense>
    ),
    handle: { crumb: null }
  },
  {
    path: '/ranking',
    element: <Navigate replace to="/leaderboard-turmas" />,
    handle: { crumb: null }
  },
  {
    path: '/leaderboard-turmas',
    element: (
      <GuardWithSuspense allowedRoles={['SUPER', 'ADM', 'PROFESSOR', 'RESPONSAVEL', 'ALUNO']}>
        <LeaderboardTurmas />
      </GuardWithSuspense>
    ),
    handle: { crumb: 'Ranking de Turmas' }
  }
];

export default routes;
